import React from 'react';
import PropTypes from 'prop-types';
import { css, cx } from 'emotion';
import Link from 'gatsby-link';
import Img from 'gatsby-image';

import gray from '../utils/gray';
import { colors, baselineGrid, radius, animation } from '../utils/presets';
import { toRem, toVW, mqObj as mq } from '../utils/functions';

const blogPrefix = 'blog';
const { speed, curve } = animation;

const blogListing = css`
  position: relative;
  width: 100%;
  margin: 0 0 ${toRem(baselineGrid * 4)};
  background-color: ${colors.ui.whisper};
  border-radius: ${radius.default};
  overflow: hidden;
  transition: transform ${speed.default} ${curve.default},
    box-shadow ${speed.default} ${curve.default};

  &:not(.blogListingLarge) {
    ${mq.lap} {
      width: calc(50% - ${toRem(baselineGrid * 2)});
    }

    ${mq.lapLarge} {
      width: calc(50% - ${toVW(baselineGrid * 4)});
    }
  }

  @media (min-width: 1568px) {
    margin: 0 0 ${toRem(baselineGrid * 6)};
  }

  & > * {
    transition: opacity ${speed.default} ${curve.default};
  }

  &:hover,
  &:active,
  &:focus {
    transform: translateY(${toRem(baselineGrid * -1)});
    box-shadow: 0 1px 2px 0 ${gray(80)};

    & > * {
      opacity: 0.88;
    }
  }
`;

const blogListingLink = css`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
`;

const blogListingImage = css`
  position: relative;
  margin: 0;
  padding-bottom: ${9 / 16 * 100}%;
  background-color: ${colors.gray.calm};

  /* ${mq.desk} {
    padding-bottom: 34vh;

    .blogListingLarge & {
      padding-bottom: 48vh;
    }
  } */

  .gatsby-image-outer-wrapper {
    position: static !important;
  }

  .gatsby-image-wrapper {
    position: absolute !important;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }
`;

const blogListingBody = css`
  padding: ${toRem(baselineGrid * 2)};

  ${mq.lapLarge} {
    padding: ${toRem(baselineGrid * 3)};

    .blogListingLarge & {
      padding: ${toRem(baselineGrid * 4)};
    }
  }

  ${mq.desk} {
    padding: ${toRem(baselineGrid * 4)};

    .blogListingLarge & {
      padding: ${toRem(baselineGrid * 6)} 5vw;
    }
  }

  ${mq.deskLarge} {
    padding: ${toRem(baselineGrid * 4)};
  }

  a[href]:not([class]) {
    text-decoration: none;
    color: inherit;
  }
`;

const blogListingHeader = css`
  margin-bottom: ${toRem(baselineGrid * 3)};
`;

const blogListingTitle = css`
  font-size: calc(${toRem(baselineGrid * 3)} + ${toVW(baselineGrid * 1)});
  margin: 0;
`;

const blogListingDate = css`
  display: block;
  font-size: ${toRem(16)};
  margin: ${toRem(baselineGrid)} 0 ${toRem(baselineGrid * 2)};
  color: ${colors.gray.gunpowder};
`;

const blogListingExcerpt = css``;

const BlogListing = ({ node, isLarge }) => (
  <article className={cx(blogListing, { blogListingLarge: isLarge })}>
    {node.frontmatter.featuredImage && (
      <figure className={blogListingImage}>
        <Img sizes={node.frontmatter.featuredImage.childImageSharp.sizes} />
      </figure>
    )}

    <div className={blogListingBody}>
      <header className={blogListingHeader}>
        <h1 className={blogListingTitle}>
          <span className={blogListingDate}>
            <Link to={`/${blogPrefix}${node.fields.slug}`}>{node.fields.created}</Link>
          </span>
          <Link to={`/${blogPrefix}${node.fields.slug}`}>{node.fields.title}</Link>
        </h1>
      </header>

      {!node.frontmatter.featuredImage && (
        <div className={blogListingExcerpt}>{node.frontmatter.excerpt || node.excerpt}</div>
      )}
    </div>

    <Link className={blogListingLink} to={`/${blogPrefix}${node.fields.slug}`} />
  </article>
);

BlogListing.propTypes = {
  node: PropTypes.object,
  isLarge: PropTypes.bool,
};

export default BlogListing;



// WEBPACK FOOTER //
// ./src/components/blog-listing.js